export const ACTIVITY = {
  id: 1,
  displayName: "Activity",
  displayOrder: 1,
};

const itemTypesMap = new Map();
itemTypesMap.set(ACTIVITY.id, ACTIVITY);

export function getItemType(typeId) {
  return itemTypesMap.get(typeId) ?? {};
}

export function getItemTypeName(typeId) {
  return itemTypesMap.get(typeId)?.displayName;
}

export const AllItemTypes = [...itemTypesMap.values()];